export default class InitLicenseViewController {
  /* @ngInject */
  constructor($async, $state, $scope, $location, LicenseService, Notifications, Authentication) {
    this.$async = $async;
    this.$state = $state;
    this.$scope = $scope;
    this.$location = $location;
    this.LicenseService = LicenseService;
    this.Notifications = Notifications;
    this.Authentication = Authentication;

    this.license = '';
    this.state = {
      actionInProgress: false,
      formError: '',
    };

    this.submit = this.submit.bind(this);
  }

  isFormValid() {
    return !!this.license;
  }

  $onInit() {
    this.leavingAfterSubmit = false;

    // Prevent bypassing license init view
    this.$scope.$on('$locationChangeStart', () => {
      if (this.leavingAfterSubmit) {
        return;
      }
      this.$location.path('/init/license');
    });
  }

  async submit() {
    return this.$async(async () => {
      this.state.formError = '';
      if (!this.isFormValid()) {
        this.state.formError = 'Form is invalid';
        return;
      }

      this.state.actionInProgress = true;

      try {
        await this.LicenseService.attach({ key: this.license }, { params: { force: true } });

        let path = 'portainer.init.edge';
        if (this.Authentication.getUserDetails().forceChangePassword) {
          path = 'portainer.account';
        }

        this.leavingAfterSubmit = true;
        await this.$state.go(path).catch(() => {
          this.leavingAfterSubmit = false;
        });
      } catch (err) {
        this.Notifications.error('Failure', err, 'Failed validating licenses');
      } finally {
        this.state.actionInProgress = false;
      }
    });
  }
}
